import { useEffect, useState } from 'react';
import { cn } from '@rocco/utils/cn';

import hdeFrame1 from './frames/hde-frame-1.svg?url';
import hdeFrame2 from './frames/hde-frame-2.svg?url';
import hdeFrame3 from './frames/hde-frame-3.svg?url';
import hdeFrame4 from './frames/hde-frame-4.svg?url';
import hdeFrame5 from './frames/hde-frame-5.svg?url';
import hdeFrame6 from './frames/hde-frame-6.svg?url';
import hdeFrame7 from './frames/hde-frame-7.svg?url';

/** Default delay between frame swaps for the profile-banner exhibitor badge. */
const DEFAULT_FRAME_INTERVAL_MS = 500;

const HDE_EXHIBITOR_BADGE_FRAMES: readonly string[] = [
    hdeFrame1,
    hdeFrame2,
    hdeFrame3,
    hdeFrame4,
    hdeFrame5,
    hdeFrame6,
    hdeFrame7,
];

interface HDEExhibitorBadgeProps {
    className?: string;
    /** Frame rotation interval in ms (default {@link DEFAULT_FRAME_INTERVAL_MS}). */
    intervalMs?: number;
}

/** Fixed rendered width for the profile-banner exhibitor badge artwork. */
const HDE_EXHIBITOR_BADGE_WIDTH_PX = 220;

/**
 * Animated Home Design Event exhibitor ribbon for the professional profile banner.
 * Loops through staff-provided frame artwork on a fixed timer.
 */
export function HDEExhibitorBadge({
    className,
    intervalMs = DEFAULT_FRAME_INTERVAL_MS,
}: HDEExhibitorBadgeProps) {
    const [frameIndex, setFrameIndex] = useState(0);

    useEffect(() => {
        if (HDE_EXHIBITOR_BADGE_FRAMES.length <= 1) {
            return undefined;
        }

        const id = window.setInterval(() => {
            setFrameIndex((i) => (i + 1) % HDE_EXHIBITOR_BADGE_FRAMES.length);
        }, intervalMs);

        return () => window.clearInterval(id);
    }, [intervalMs]);

    return (
        <div
            className="relative flex shrink-0 items-start justify-end"
            role="img"
            aria-label="Home Design Event exhibitor"
        >
            <img
                data-testid="hde-exhibitor-badge-frame"
                src={HDE_EXHIBITOR_BADGE_FRAMES[frameIndex]}
                alt=""
                className={cn('h-[392px] w-[220px] object-contain', className)}
                width={HDE_EXHIBITOR_BADGE_WIDTH_PX}
                decoding="async"
                aria-hidden
            />
        </div>
    );
}
